import sanitizeHtml from 'sanitize-html';

const allowedDefaults = setupSanitizeDefaults();

// override defaults
function setupSanitizeDefaults() {
    try {
        sanitizeHtml.defaults.allowedAttributes['a'].push('rel', 'class');
    } catch (e) {
        console.error(e);
    }

    return sanitizeHtml.defaults;
}

export default {
    install: (Vue) => {
        Vue.filter('sanitize', sanitizer);
    },
};

export function sanitizer(rawHtml) {
    return sanitizeHtml(rawHtml, allowedDefaults);
}
